module.exports = __webpack_public_path__ + "img/Entity.b07e0a25.svg";